import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const container = document.getElementById("root");

if (!container) {
  throw new Error('Elemento con id "root" non trovato in public/index.html');
}

const root = ReactDOM.createRoot(container);
root.render(<App />);
